<form [formGroup]="projectSettingForm">
    @if (isLoading()) {
        <div class="grid w-full gap-6 sm:grid-cols-4">
            @for (field of formFields(); track field.controlName) {
                <div class="animate-pulse sm:col-span-2">
                    <div class="mb-2 h-4 w-40 rounded bg-gray-200"></div>
                    <div class="h-12 w-full rounded bg-gray-200"></div>
                </div>
            }
        </div>
    } @else {
        <div class="space-y-8">
            <section class="space-y-4">
                <div>
                    <h3 class="text-lg font-semibold text-primary">General</h3>
                    <p class="text-sm text-secondary">These fees always apply to this sidemark</p>
                </div>

                <div class="grid w-full gap-6 sm:grid-cols-4">
                    <ng-container *ngTemplateOutlet="fieldGroup; context: { $implicit: generalFields(), empty: 'No general pricing fields are available.' }"></ng-container>
                </div>
            </section>

            @if (isAllInclusive()) {
            <section class="space-y-4">
                <div>
                    <h3 class="text-lg font-semibold text-primary">All Inclusive</h3>
                    <p class="text-sm text-secondary">These fees are configurable at the sidemark level</p>
                </div>

                <div class="grid w-full gap-6 sm:grid-cols-4">
                    <ng-container *ngTemplateOutlet="fieldGroup; context: { $implicit: allInclusiveFields(), empty: 'No all inclusive pricing fields are available.' }"></ng-container>
                </div>
            </section>
            } @else {
            <section class="space-y-4">
                <div>
                    <h3 class="text-lg font-semibold text-primary">Per Service</h3>
                    <p class="text-sm text-secondary">These fees are configurable at the sidemark level</p>
                </div>

                <div class="grid w-full gap-6 sm:grid-cols-4">
                    <ng-container *ngTemplateOutlet="fieldGroup; context: { $implicit: perServiceFields(), empty: 'No per service pricing fields are available.' }"></ng-container>
                </div>
            </section>
            }
        </div>

        <ng-template #fieldGroup let-fields let-emptyMessage="empty">
            @for (field of fields; track field.controlName) {
            <div class="sm:col-span-2">
                <mat-form-field class="w-full" subscriptSizing="dynamic">
                    <mat-label>{{ field.label }}</mat-label>
                    <mat-icon class="icon-size-5" [svgIcon]="field.icon" matPrefix></mat-icon>

                    @if (field.type === 'percent') {
                        <input [formControlName]="field.controlName" suffix="%" mask="percent.2" min="0" max="100" [readonly]="isFieldReadonly(field)" matInput>
                    } @else if (field.type === 'integer') {
                        <input [formControlName]="field.controlName" mask="separator.0" [readonly]="isFieldReadonly(field)" matInput>
                    } @else {
                        <input [formControlName]="field.controlName" mask="separator.2" prefix="$" thousandSeparator="," [readonly]="isFieldReadonly(field)" matInput>
                    }

                </mat-form-field>
                @if (!isFieldReadonly(field)) {
                    @if (projectSettingForm.controls[field.controlName]?.errors?.['required'] && projectSettingForm.controls[field.controlName].touched) {
                        <mat-error>{{ field.label }} is required</mat-error>
                    }

                    @if (projectSettingForm.controls[field.controlName]?.errors?.['min'] && projectSettingForm.controls[field.controlName].touched) {
                        <mat-error>{{ field.label }} must be at least 0</mat-error>
                    }

                    @if (projectSettingForm.controls[field.controlName]?.errors?.['max'] && projectSettingForm.controls[field.controlName].touched) {
                        <mat-error>{{ field.label }} must be at most 100</mat-error>
                    }
                }
            </div>
            } @empty {
            <div class="sm:col-span-4 text-sm text-secondary">
                {{ emptyMessage }}
            </div>
            }
        </ng-template>
    }

    @if (!isDialogSetting()) {
    <div class="mt-8 flex items-center justify-end">
        <button mat-flat-button type="submit" color="primary" class="px-10" [disabled]="saveDisabled()" (click)="submitProjectSettings()">
            Save
        </button>
    </div>
    }
</form>